// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2WZjR","amount":"Amount_amount__3bV1U","tip":"Amount_tip__DC8I0","tipHeader":"Amount_tipHeader__3Z3lj","tipsWrap":"Amount_tipsWrap__2bjxL"};